import apiClient from './client';

export interface ContactFormData {
  name: string;
  email: string;
  message: string;
  turnstileToken: string;
}

export async function submitContactForm(data: ContactFormData): Promise<void> {
  await apiClient.post('/Contact', data);
}
